import { Star } from "lucide-react";

export default function StarRating({ rating = 0, size = 14, showNumber = true, count }) {
  const r = Number(rating) || 0;
  const stars = [1, 2, 3, 4, 5].map((i) => {
    const full = r >= i;
    const half = !full && r >= i - 0.5;
    return (
      <span key={i} className="inline-flex">
        <Star
          width={size}
          height={size}
          className={full || half ? "text-lokaso-gold" : "text-stone-300"}
          fill={full ? "#E8A020" : half ? "url(#half)" : "transparent"}
          stroke="#E8A020"
          strokeWidth={1.5}
        />
      </span>
    );
  });
  return (
    <div className="inline-flex items-center gap-1" data-testid="star-rating">
      <div className="inline-flex">{stars}</div>
      {showNumber && (
        <span className="text-sm font-medium text-lokaso-dark">{r.toFixed(1)}</span>
      )}
      {typeof count === "number" && (
        <span className="text-xs text-stone-500">({count})</span>
      )}
    </div>
  );
}
